import { LIFECYCLE_STATUS_GUID } from './constants';

// A lifecycle halts on the phase that ended it rather than advancing, so that phase keeps
// IsCurrent. Matching on IsCurrent alone therefore still picks up the approvals and tasks of
// a failed phase, and the board offers live approve/reject on them. #35357
export const isLifecycleRunning = (statusGuid?: string): boolean =>
  statusGuid !== LIFECYCLE_STATUS_GUID.FAILED && statusGuid !== LIFECYCLE_STATUS_GUID.COMPLETED;

// The same rule as OData, for the board and list queries. `prefix` is the path from the entity
// being queried to the phase: "Approval/" from ticketapprovals, "" from tickettasks. Both reach
// the lifecycle the same way, through the ticket.
export const currentPhaseFilter = (prefix: string, isLifecycleEnabled: boolean): string => {
  if (!isLifecycleEnabled) return `(${prefix}TicketLifecyclePhaseId eq null)`;

  return `(${prefix}TicketLifecyclePhaseId eq null or (${prefix}TicketLifecyclePhase/IsCurrent eq true`
    + ` and Ticket/TicketLifecycle/Status/Guid ne ${LIFECYCLE_STATUS_GUID.FAILED}`
    + ` and Ticket/TicketLifecycle/Status/Guid ne ${LIFECYCLE_STATUS_GUID.COMPLETED}))`;
};
